import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router";

import { style } from "style";
import urls from "utils/constants/urls";
import { showAcademyAppOnlyModal } from "./helper";

const AcademyBlockedRoute = ({ component: Component }) => {
  const dispatch = useDispatch();

  const shouldBlockAcademyWeb = ["Pintou Parceria Suvinil", "NOZ"].includes(
    style.names.nameApp,
  );

  useEffect(() => {
    if (shouldBlockAcademyWeb) {
      showAcademyAppOnlyModal(dispatch);
    }
  }, [dispatch, shouldBlockAcademyWeb]);

  if (shouldBlockAcademyWeb) {
    return <Redirect to={urls.ROUTES.ACADEMY} />;
  }

  return <Component />;
};

AcademyBlockedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default AcademyBlockedRoute;
